import { Component, OnInit, OnDestroy } from '@angular/core';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { AccountInfo, EventMessage, EventType } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app';
  private readonly _destroying$ = new Subject<void>();

  constructor(public msalService: MsalService, private msalBroadcastService: MsalBroadcastService) { }

  ngOnInit() {
    // Show OneTrust banner if user is already logged in (e.g., page refresh with cached session)
    if (this.isLoggedIn()) {
      this.showOneTrustBanner();
    }

    // Listen for MSAL login success to show OneTrust banner after authentication
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) =>
          msg.eventType === EventType.LOGIN_SUCCESS ||
          msg.eventType === EventType.SSO_SILENT_SUCCESS ||
          msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
          msg.eventType === EventType.HANDLE_REDIRECT_END
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        if (this.isLoggedIn()) {
          this.showOneTrustBanner();
        }
      });
  }

  ngOnDestroy() {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  isLoggedIn(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  getUserName(): string | null {
    const account: AccountInfo | undefined =
      this.msalService.instance.getActiveAccount() ||
      this.msalService.instance.getAllAccounts()[0];
    return account ? account.username : null;
  }

  private showOneTrustBanner(): void {
    document.body.classList.add('onetrust-visible');
  }
}



